import { useAppSelector } from '@/Hook/hooks';
import { getCompanyDetails, setCompanyDetails } from '@/Utils/auth';
import classNames from 'classnames';

function LanguageSelector() {
  const { selectedLanguage, languageOptions } = useAppSelector((state) => ({
    selectedLanguage: state.User.languageno,
    languageOptions: state.User.clientLanguage
  }))

  const changeLanguage = (lang: any) => {
    const companyDetails = getCompanyDetails();
    setCompanyDetails({
      timezone: companyDetails.timezone,
      selectedLegalEntity: companyDetails.selectedLegalEntity,
      selectedLang: lang
    });

    location.reload();
  }

  return languageOptions.length >= 1 ? (
    <div className="d-flex gap-2 align-items-center">
      {
        languageOptions.map((lang: any) => (
          <div key={lang.languageno} className={classNames(["badge text-dark", { "bg-outline-primary rounded-pill text-white": lang.languageno == selectedLanguage }])} onClick={() => changeLanguage(lang.languageno)}>
            {lang.languagenostxt}
          </div>
        ))
      }
    </div>
  ) : null
}

export default LanguageSelector;